var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"claim-container"},[_c('Typography',{attrs:{"variant":"subtitle-1"}},[_vm._v("Claim ID: "+_vm._s(_vm.claim.formSubmissionEntryId))]),(_vm.claim.reviewerComment)?_c('Alert',{attrs:{"message":_vm.claim.reviewerComment}}):_vm._e(),_c('ClaimProductInfo',{attrs:{"claim":_vm.claim,"includeDescription":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }